import e from"react";import r from"./utils/createSvgIcon.js";var t=r(e.createElement("path",{d:"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"}),"ExpandMore");export{t as default};
